import cn from "classnames";
import type { ComponentProps } from "react";
import { TbCheck, TbSparkles } from "react-icons/tb";
import styles from "./LabelButton.module.css";

export interface LabelButtonProps extends ComponentProps<"button"> {
  selected?: boolean;
}

export function LabelButton(props: LabelButtonProps) {
  const { selected, className, type = "button", children, ...rest } = props;

  const Icon = selected ? TbCheck : TbSparkles;

  return (
    <button
      type={type}
      className={cn(styles.button, className, { [styles.selected]: selected })}
      {...rest}
    >
      <Icon
        className={cn(styles.icon, { [styles.iconSelected]: selected })}
        strokeWidth={3}
      />
      <span>{props.children}</span>
    </button>
  );
}
